module.exports = __webpack_public_path__ + "assets/images/ote_sport_2.274b93f104d7c488c6a5b58d1f1b43cc.png";